import _objectSpread from "C:/Users/amirs/Documents/Projects/top-menu-panel/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from "vuex";
import providerApiService from "../../../services/api/ProviderApiService";
export default {
  name: "Form.vue",
  data: function data() {
    var _this$selectedTable, _this$selectedTable2;

    return {
      title: (_this$selectedTable = this.selectedTable) === null || _this$selectedTable === void 0 ? void 0 : _this$selectedTable.title,
      capacity: (_this$selectedTable2 = this.selectedTable) === null || _this$selectedTable2 === void 0 ? void 0 : _this$selectedTable2.capacity
    };
  },
  computed: _objectSpread({}, mapGetters({
    currentProvider: "profile/currentProvider"
  })),
  props: {
    selectedTable: {
      type: [Object, null],
      required: true
    }
  },
  methods: {
    handleOnSubmit: function handleOnSubmit() {
      var _this$selectedTable3,
          _this = this;

      this.$vs.loading();
      providerApiService.createTable({
        title: this.title,
        capacity: this.capacity,
        providerId: this.currentProvider.id,
        tableId: (_this$selectedTable3 = this.selectedTable) === null || _this$selectedTable3 === void 0 ? void 0 : _this$selectedTable3.id
      }).then(function () {
        return _this.$emit("onTableChanged");
      }).catch(function (e) {
        return console.log(e);
      }).finally(function () {
        return _this.$vs.loading.close();
      });
    }
  }
};